module.exports = __webpack_public_path__ + "img/organisation.032753fe.jpg";